// Formattering for varekortet (nb-NO).

export const formatQty = (n: number | null | undefined): string => {
  if (n === null || n === undefined) return '-';
  return n.toLocaleString('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

export const formatDate = (d: string | null | undefined): string => {
  if (!d) return '-';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('nb-NO', { year: 'numeric', month: '2-digit', day: '2-digit' });
};

export const formatDateTime = (d: string | null | undefined): string => {
  if (!d) return '-';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleString('nb-NO', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
};
